import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { Grid, Typography } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { Loading } from './../../../components/includes/loading';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Modal } from './../../../components/includes/modal';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { isEmail, isPasswordValid } from './../../../utilities/utils';
import { UserService, PermissionService } from './../../../services';
import Password from './../password';
import Permission from './../permission';

import VALIDATION from './../../../config/validation';
import ROLES from './../../../config/roles';

const validate = values => {

  const errors = {}

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 256){
    errors.name = 'The maximum is 256 characters';
  }

  if (!values.surname) {
    errors.surname = VALIDATION.required;
  }else if(values.surname.length > 256){
    errors.surname = 'The maximum is 256 characters';
  }

  if (!values.email) {
    errors.email = VALIDATION.required;
  } else if (isEmail(values.email)) {
    errors.email = VALIDATION.email;
  } else if (values.email.length > 256){
    errors.email = 'The maximum is 256 characters';
  }

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (!values.password) {
    errors.password = VALIDATION.required;
  } else if( !isPasswordValid(values.password) ){
    errors.password = VALIDATION.password;
  }

  if (!values.confirm_password) {
    errors.confirm_password = VALIDATION.required;
  } else if (values.confirm_password !== values.password) {
    errors.confirm_password = VALIDATION.mismatched_password;
  }

  return errors

};

class UserUpdate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      id: null,
      loading: false,
      formChangePasswordShow: false,
      permissionsAvailable: []
    };
  }

  componentDidMount(){

    // @Service
    // @Description: Listado de permisos
    this._Permission();

    // @Service
    // @Description: Informacion del usuario
    this._Find(this.props.match.params.id);

  }

  /*
  ** @Service
  ** @Description: Find
  */

  _Find = (id) => {

    UserService.find(id).then((response) => {

      // @Change
      // @Description: list permissions by user permissions
      const userPermissions = response.user.permissions;

      // Reemplazo el listado del usuario, por todos los disponibles
      response.user.permissions = this.state.permissionsAvailable;

      // Marco los que tiene seleccionados
      response.user.permissions.forEach(permission => {
        let p =  userPermissions.find(x => x._id === permission._id);
        if(p){
          permission.checked = true;
        }
      });

    //  console.log(response);

      // @State
      this.setState({ loading: true, id: id });

      // @Dispatch
      this.props.Update(response);

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Service
  ** @Description: Update
  */

  _Update = (values) => {

    // @Loading
    this.setState({ loading: false });

    // @Service
    UserService.update(this.state.id, values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/users');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exitio, el registro fue editado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Service
  ** @Description: List of permissions
  */

  _Permission = () => {

    PermissionService.get().then((response) => {

      this.setState({ permissionsAvailable: response.permissions });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: 'error'});

    });

  }

  /*
  ** @Event
  ** @Description: Submit button
  */

  handleSubmitForm = (values) => {
    this._Update(values);
  }

  /*
  ** @Event
  ** @Description: change password
  */

  handleChangePassword = () => {
    this.setState({ formChangePasswordShow: true });
  }

  /*
  ** @Event
  ** @Description: Close change password
  */

  handleCancelChangePassword = () => {
    this.setState({ formChangePasswordShow: false });
  }

  /*
  ** @Submit
  ** @Description: Toogle permissions
  */
  handleTooglePermision = (index, status) => {

    // @Change
    // @Description: list permissions by user permissions
    let user = this.props.UserUpdate;
        user.permissions[index].checked = status;

    // @Dispatch
    this.props.Update({ user: user });

    setTimeout(() => {
      console.log(this.props.UserUpdate)
    },2000);


    //this.props.dispatch(change("UserCreate", `permissions_available[${index}].checked`, status))
  }

  render() {

    const { loading, id, formChangePasswordShow } = this.state;
    const { UserUpdate, handleSubmit, invalid } = this.props;

    return (
      <Section>

        <ToolbarPrimary title="Usuarios"/>
        <BreadcrumbItem to='/users'>Usuarios</BreadcrumbItem>
        <BreadcrumbItem to='/update'>Editar</BreadcrumbItem>

        <Content>

          <Main>

            { loading ? (

              <div>

                <Modal
                    status={ formChangePasswordShow }
                    title={ `Cabio de contraseña: ${ UserUpdate.name } ${ UserUpdate.surname }` }
                    handleCancel={ this.handleCancelChangePassword }
                    maxWidth="sm">
                    <Password id={ id } onSuccess={ this.handleCancelChangePassword }/>
                </Modal>

                <form noValidate autoComplete="off"  onSubmit={ handleSubmit(this.handleSubmitForm) }>

                <Ttolbar title={ `${ UserUpdate.name } ${ UserUpdate.surname }` }/>

                <FormContent enabledActions>

                  <Grid container spacing={24}>
                    <Grid item lg={4} md={4} sm={12}>
                      <Field
                          name="name"
                          component={ InputTextField }
                          label="Nombre"
                          type="text"
                          required
                      />
                    </Grid>
                    <Grid item lg={4} md={4} sm={12}>
                      <Field
                          name="surname"
                          component={ InputTextField }
                          label="Apellido"
                          type="text"
                          required
                      />
                    </Grid>
                    <Grid item lg={4} md={4} sm={12}>
                      <Field
                          name="email"
                          component={ InputTextField }
                          label="Email"
                          type="email"
                          required
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={24}>
                    <Grid item lg={4} md={4} sm={12}>
                      <Field
                          name="status"
                          component={ SelectField }
                          label="Estado" required>
                            <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                            <OptionField key="true" value="true">Activo</OptionField>
                            <OptionField key="false" value="false">Bloqueado</OptionField>
                      </Field>
                    </Grid>
                    <Grid item lg={4} md={4} sm={12}>
                      <Field
                          name="role"
                          component={ SelectField }
                          label="Profile" required>
                            <OptionField key="1" value="-1">Seleccionar...</OptionField>
                            { ROLES.length > 0 && (
                              ROLES.map(role => {
                                return(
                                  <OptionField key={ role.key } value={ role.key }>{ role.name }</OptionField>
                                )
                              })
                            )}
                      </Field>
                    </Grid>
                  </Grid>

                  <Grid container spacing={24}>
                    <Grid item lg={12} md={12} sm={12}>
                      <Typography variant="h6">Permisos</Typography>
                      <FieldArray name="permissions_available" component={ Permission } onChange={ this.handleTooglePermision }/>
                    </Grid>
                  </Grid>

                </FormContent>

                <FormActions>
                  <Grid container>
                    <Grid item lg={6} md={6} sm={12}>
                      <Buttons>
                        <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/users">
                          Volver
                        </Btn>
                      </Buttons>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12}>
                      <Buttons align="right">
                        <Btn aria-label="Cambiar Contraseña" color="primary" onClick={ this.handleChangePassword }>
                          Cambiar contraseña
                        </Btn>
                        <Btn aria-label="Guardar" icon="add" color="success" type="submit" disabled={ invalid }>
                          Guardar
                        </Btn>
                      </Buttons>
                    </Grid>
                  </Grid>
                </FormActions>

              </form>

              </div>

            ) : (
              <Loading variant="primary"/>
            )}

          </Main>

        </Content>
      </Section>
    )
  }
}

UserUpdate = reduxForm({
  form: 'UserUpdate',
  validate,
  enableReinitialize: true
})(UserUpdate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert,
    UserUpdate: state.UserUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Update: (data) => {
      dispatch({
        type: 'USER_UPDATE',
        data: data
      });
    }
  }
}

UserUpdate = connect(
  state => ({
    initialValues: {
      name: state.UserUpdate.name,
      surname: state.UserUpdate.surname,
      email: state.UserUpdate.email,
      status: String(state.UserUpdate.status),
      role: state.UserUpdate.role,
      permissions_available: state.UserUpdate.permissions
    }
  })
)(UserUpdate);

export default connect(mapStateToProps, mapDispatchToProps)(UserUpdate);
